import { createApp } from 'vue';
import HeicToWebpConverter from '../Components/HeicToWebpConverter.vue';

const root = document.getElementById('heic-to-webp-converter');
if (root) {
  createApp(HeicToWebpConverter).mount('#heic-to-webp-converter');
}
